import { render, staticRenderFns } from "./Profile_component.vue?vue&type=template&id=307d1a4a&"
import script from "./Profile_component.vue?vue&type=script&lang=js&"
export * from "./Profile_component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports